import { useExternalParams } from 'shared/hooks/use-external-params';
import { useMemo } from 'react';
import { DateTime } from 'luxon';
import { ProjectPlanningFilters } from './use-project-planning-filters.types';
import { stringifyProjectFilters } from '../stringify-project-filters';
import { FilledStatus } from '../../../../../../../shared/components/filters/inputs/filled-status/filter-filled-status.types';

export const PROJECT_PLANNING_INITIAL_VALUES = {
  toDate: {
    initialValue: DateTime.now(),
    type: 'date',
  },
  companyId: {
    initialValue: undefined,
    type: 'string',
  },
  branchOffices: {
    initialValue: undefined,
    type: 'string_array',
  },
  departments: {
    initialValue: undefined,
    type: 'string_array',
  },
  filledStatus: {
    initialValue: undefined,
    type: 'string',
  },
  hasApplicants: {
    initialValue: undefined,
    type: 'boolean',
  },
  jobType: {
    initialValue: undefined,
    type: 'string_array',
  },
  workerId: {
    initialValue: undefined,
    type: 'string',
  },
  projectId: {
    initialValue: undefined,
    type: 'string',
  },
} as const;

export const useProjectPlanningFilters = () => {
  const [params, setParams] = useExternalParams(PROJECT_PLANNING_INITIAL_VALUES);

  const filters: ProjectPlanningFilters = useMemo(() => {
    return {
      toDate: params.toDate || undefined,
      companyId: params.companyId || undefined,
      branchOffices: params.branchOffices as string[] | undefined,
      departments: params.departments as string[] | undefined,
      filledStatus: (params.filledStatus as FilledStatus) || undefined,
      hasApplicants: params.hasApplicants ?? undefined,
      jobType: params.jobType as string[] | undefined,
      workerId: params.workerId ?? undefined,
    };
  }, [params]);

  const selectedFilterCount = Object.values(filters).filter((value) => {
    return value !== null && value !== undefined && value !== '';
  }).length;

  const strigifiedFilters = useMemo(() => stringifyProjectFilters(filters), [filters]);
  const setProjectId = (projectId: string | undefined) => setParams({ projectId });

  return {
    filters,
    setFilters: setParams,
    selectedFilterCount,
    strigifiedFilters: strigifiedFilters,
    projectId: params.projectId,
    setProjectId,
  };
};
